/*
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-08-23 21:34:19
 * @LastEditTime: 2019-08-24 20:03:41
 * @Version: 1.0
 * @Description:  路由配置文件
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [

  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index'),
    redirect: { name: 'Home' },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/home'),
        meta: { title: '首页' }
      },
      {
        path: '/enterprise-show',
        name: 'EnterpriseShow',
        component: () => import('@/views/enterprise-show'),
        meta: { title: '企业展示' },
        redirect: 'enterprise-show/exhibition',
        children: [
          {
            path: '/enterprise-show/exhibition',
            name: 'exhibition',
            component: () => import('@/views/enterprise-show/exhibition.vue'),
            meta: { title: '企业展示' }
          },
          {
            path: '/enterprise-show/exhibition/list',
            name: 'list',
            component: () => import('@/views/enterprise-show/list.vue'),
            meta: { title: '资讯列表' }
          },
          {
            path: '/enterprise-show/exhibition/detailsSee',
            name: 'detailsSee',
            component: () => import('@/views/enterprise-show/detailsSee.vue'),
            meta: { title: '资讯详情' }
          }
        ]
      },
      {
        path: 'petro-transport',
        name: 'PetroTransport',
        component: () => import('@/views/petro-transport'),
        meta: { title: '石化运输' },
        children: [
          {
            path: '/petro-transport/SourceNews',
            name: 'SourceNews',
            component: () => import('@/views/petro-transport/SourceNews.vue'),
            meta: { title: '货源信息' }
          },
          {
            path: '/petro-transport/TransportNews',
            name: 'TransportNews',
            component: () => import('@/views/petro-transport/TransportNews.vue'),
            meta: { title: '运输信息' }
          }
        ]
      },
      {
        path: 'cloud',
        name: 'Cloud',
        component: () => import('@/views/cloud'),
        meta: { title: '石化云仓' },
        children: [
          {
            path: '/cloud/tank-supply-info',
            name: 'TankSupplyInfo',
            component: () => import('@/views/cloud/tank-supply-info'),
            meta: { title: '罐区供给信息' }
          },
          {
            path: '/cloud/storage-supply-info',
            name: 'TtorageSupplyInfo',
            component: () => import('@/views/cloud/storage-supply-info'),
            meta: { title: '普通仓库供给信息' }
          },
          {
            path: '/cloud/storage-demand-info',
            name: 'TtorageDemandInfo',
            component: () => import('@/views/cloud/storage-demand-info'),
            meta: { title: '普通仓库需求信息' }
          },
          {
            path: '/cloud/tank-demand-info',
            name: 'TankDemandInfo',
            component: () => import('@/views/cloud/tank-demand-info'),
            meta: { title: '罐区需求信息' }
          }
        ]
      },
      {
        path: 'monitor',
        name: 'Monitor',
        component: () => import('@/views/monitor'),
        meta: { title: '物流监控' },
        children: [
          {
            path: '/monitor/order-info',
            name: 'OrderInfo',
            component: () => import('@/views/monitor/order-info'),
            meat: { title: '订单信息' }
          },
          {
            path: '/monitor/waybill-route',
            name: 'WaybillRoute',
            component: () => import('@/views/monitor/waybill-route'),
            meat: { title: '运单轨迹' }
          }
        ]
      },
      {
        path: 'personal',
        name: 'personal',
        component: () => import('@/views/personal'),
        meta: { title: '个人中心' },
        children: [
          {
            path: 'user',
            name: 'Name',
            component: resolve => require(['@/views/personal/user'], resolve),
            meta: { title: '个人中心' },
            children: [
              {
                path: 'news-notice',
                name: 'NewsNotice',
                component: resolve => require(['@/views/personal/user/news-notice'], resolve),
                meta: { title: '消息通知' }
              },
              {
                path: 'my-collection',
                name: 'My-Collection',
                component: resolve => require(['@/views/personal/user/my-collection'], resolve),
                meta: { title: '我的收藏' }
              },
              {
                path: 'user-info',
                name: 'UserInfo',
                component: resolve => require(['@/views/personal/user/user-info'], resolve),
                meta: { title: '用户信息' }
              },
              {
                path: 'qualifications-authen',
                name: 'QualificationsAuthen',
                component: resolve => require(['@/views/personal/user/qualifications-authen'], resolve),
                meta: { title: '资质认证' }
              },
              {
                path: 'parss-modify',
                name: 'ParssModify',
                component: resolve => require(['@/views/personal/user/parss-modify'], resolve),
                meta: { title: '密码修改' }
              },
              {
                path: 'feedback',
                name: 'Feedback',
                component: resolve => require(['@/views/personal/user/feedback'], resolve),
                meta: { title: '意见反馈' }
              },
              {
                path: 'appeal',
                name: 'Appeal',
                component: resolve => require(['@/views/personal/user/appeal'], resolve),
                meta: { title: '申诉' }
              }
            ]
          },

          {
            path: 'goods',
            name: 'Goods',
            redirect: { name: 'GoodsList' },
            component: resolve => require(['@/views/personal/goods'], resolve),
            meta: { title: '货源列表' },
            children: [
              {
                path: 'goods-list',
                name: 'GoodsList',
                component: resolve => require(['@/views/personal/goods/goods-list'], resolve),
                meta: { title: '货源列表' }
              }, {
                path: 'publish-goods',
                name: 'PublishGoods',
                component: resolve => require(['@/views/personal/goods/publish-goods'], resolve),
                meta: { title: '发布货源' }
              }
              // ,{
              //   path: 'offer-list',
              //   name: 'OfferList',
              //   component: resolve => require(['@/views/personal/goods/offer-list'], resolve),
              //   meta: { title: '报价列表' }
              // }
            ]
          },

          {
            path: 'store',
            name: 'Store',
            component: resolve => require(['@/views/personal/store'], resolve),
            meta: { title: '仓储管理' },
            children: [
              {
                path: 'publish-demand',
                name: 'PublishDemand',
                component: resolve => require(['@/views/personal/store/publish-demand'], resolve),
                meta: { title: '发布仓储需求' }
              },
              {
                path: 'publish-supply',
                name: 'PublishSupply',
                component: resolve => require(['@/views/personal/store/publish-supply'], resolve),
                meta: { title: '发布仓储供给' }
              },
              {
                path: 'store-demand-list',
                name: 'StoreDemandList',
                component: resolve => require(['@/views/personal/store/store-demand-list'], resolve),
                meta: { title: '普仓需求列表' }
              },
              {
                path: 'tank-demand-list',
                name: 'TankDemandList',
                component: resolve => require(['@/views/personal/store/tank-demand-list'], resolve),
                meta: { title: '罐区需求列表' }
              },
              {
                path: 'store-supply-list',
                name: 'StoreSupplyList',
                component: resolve => require(['@/views/personal/store/store-supply-list'], resolve),
                meta: { title: '普仓供给列表' }
              },
              {
                path: 'tank-supply-list',
                name: 'TankSupplyList',
                component: resolve => require(['@/views/personal/store/tank-supply-list'], resolve),
                meta: { title: '罐区供给列表' }
              },
              {
                path: 'my-invitation',
                name: 'MyInvitation',
                component: resolve => require(['@/views/personal/store/my-invitation'], resolve),
                meta: { title: '我的邀请' }
              },
              {
                path: 'my-appointment',
                name: 'MyAppointment',
                component: resolve => require(['@/views/personal/store/my-appointment'], resolve),
                meta: { title: '我的预约' }
              },
              {
                path: 'cover-appointment',
                name: 'CoverAppointment',
                component: resolve => require(['@/views/personal/store/cover-appointment'], resolve),
                meta: { title: '预约看仓' }
              },
              {
                path: 'cover-invitation',
                name: 'CoverInvitation',
                component: resolve => require(['@/views/personal/store/cover-invitation'], resolve),
                meta: { title: '看仓邀请' }
              }

            ]
          },

          {
            path: 'transport',
            name: 'Transport',
            component: resolve => require(['@/views/personal/transport'], resolve),
            meta: { title: '运力管理' },
            children: [
              {
                path: 'publish-transport',
                name: 'PublishTransport',
                component: resolve => require(['@/views/personal/transport/publish-transport'], resolve),
                meta: { title: '发布运力' }
              },
              {
                path: 'transport-list',
                name: 'TransportList',
                component: resolve => require(['@/views/personal/transport/transport-list'], resolve),
                meta: { title: '运力列表' }
              },
              {
                path: 'invitated-list',
                name: 'InvitatedList',
                component: resolve => require(['@/views/personal/transport/invitated-list'], resolve),
                meta: { title: '我的邀请' }
              },
              {
                path: 'my-offer',
                name: 'MyOffer',
                component: resolve => require(['@/views/personal/transport/my-offer'], resolve),
                meta: { title: '我的报价' }
              }
            ]
          },

          {
            path: 'enterprise',
            name: 'Enterprise',
            meta: { title: '企业管理' },
            component: resolve => require(['@/views/personal/enterprise'], resolve),
            children: [
              {
                path: 'auch-admin',
                name: 'AuchAdmin',
                component: resolve => require(['@/views/personal/enterprise/auch-admin'], resolve),
                meta: { title: '权限管理' }
              },
              {
                path: 'company-info',
                name: 'CompanyInfo',
                component: resolve => require(['@/views/personal/enterprise/company-info'], resolve),
                meta: { title: '企业信息' }
              },
              {
                path: 'staff',
                name: 'Staff',
                component: resolve => require(['@/views/personal/enterprise/staff'], resolve),
                meta: { title: '员工管理' }
              },
              {
                path: 'sponsor',
                name: 'Sponsor',
                component: resolve => require(['@/views/personal/enterprise/sponsor'], resolve),
                meta: { title: '赞助记录' }
              }
            ]
          },
          {
            path: 'customer',
            name: 'Customer',
            component: resolve => require(['@/views/personal/customer'], resolve),
            meta: { title: '客户管理' },
            children: [
              {
                path: 'business-enterprise',
                name: 'BusinessEnterprise',
                component: resolve => require(['@/views/personal/customer/business-enterprise'], resolve),
                meta: { title: '业务公司' }
              },
              {
                path: 'contacts',
                name: 'contacts',
                component: () => import('@/views/personal/customer/contacts'),
                meta: { title: '联系人' }
              }
            ]
          },
          {
            path: 'order-list',
            name: 'OrderList',
            component: () => import('@/views/personal/order-list'),
            meta: { title: '订单列表' }
          }
          // {
          //   path: 'reserve-order-list',
          //   name: 'reserveOrderList',
          //   component: resolve => require(['@/views/personal/order-list/reserveOrderList'], resolve),
          //   meta: { title: '储备订单' }
          // }
        ]
      }
    ]
  },
  {
    path: '/log',
    name: 'Log',
    component: () => import('@/views/log'),
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/log/login'),
        meat: { title: '登录' }
      },
      {
        path: 'reg',
        name: 'Reg',
        component: () => import('@/views/log/reg'),
        meat: { title: '注册' }
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/404'),
    meat: { title: '404' }
  }
]

const createRouter = () => new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: constantRoutes
})
const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};



export default router
